<template>
  <b-overlay
    id="overlay-background"
    :show="customVariableBusy"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-card>
      <b-card-header class="generalInfoHeader">
        <b-card-title>{{ $t('DEBTIA_GENERAL_INFORMATION') }}</b-card-title>
        <b-card-title class="text-primary">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="mr-1"
            @click="updateGeneralInfo"
          >
            {{ $t('DEBTIA_UPDATE') }}
          </b-button>
        </b-card-title>
      </b-card-header>
      <validation-observer
        ref="infoRules"
        tag="form"
      >
        <b-form>
          <b-row>
            <b-col
              v-for="(variable, index) in variables"
              :key="variable.id === 0 ? variable.customVarLabel+'_'+variable.custom_variable_id : variable.id"
              cols="6"
            >
              <div v-if="variable.display_in_detail_page === 1 || variable.display_in_detail_page === true">
                <b-form-group
                  :label="$t(variable.customVarLabel)"
                  :label-for="`var_type_${variable.id === 0 ? variable.custom_variable_id : variable.id}`"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(variable.customVarLabel)"
                    :rules="getRules(variable.is_required, variable.type)"
                  >
                    <vue-timepicker
                      v-if="variable.type === 'time'"
                      :id="`var_type_${variable.id === 0 ? variable.custom_variable_id : variable.id}`"
                      v-model="variable.customVarValue"
                      input-width="100%"
                      input-class="form-control"
                      manual-input
                      hide-clear-button
                    />
                    <b-input-group
                      v-else-if="variable.type === 'date'"
                    >
                      <cleave
                        :id="`var_type_${variable.id === 0 ? variable.custom_variable_id : variable.id}`"
                        v-model="caseGeneralDates[`da${variable.customVarLabel}`]"
                        class="form-control"
                        :raw="false"
                        :options="options.date"
                        placeholder="DD-MM-YYYY"
                        @input="validateDate(0, caseGeneralDates[`da${variable.customVarLabel}`], null, index)"
                      />
                      <b-input-group-append>
                        <b-form-datepicker
                          :id="`var_type_${variable.id === 0 ? variable.custom_variable_id : variable.id}`"
                          v-model="variable.customVarValue"
                          :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                          trim
                          button-only
                          right
                          size="sm"
                          @input="validateDate(1, variable.customVarValue, variable.customVarLabel, index)"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-textarea
                      v-else-if="variable.type === 'multiline string'"
                      :id="`var_type_${variable.id === 0 ? variable.custom_variable_id : variable.id}`"
                      v-model="variable.customVarValue"
                      :placeholder="variable.variable"
                      rows="3"
                    />
                    <v-select
                      v-else-if="variable.type === 'select'"
                      :id="`var_type_${variable.id === 0 ? variable.custom_variable_id : variable.id}`"
                      v-model="variable.customVarValue"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="variable.options.length > 0 ? variable.options : airports"
                      :reduce="val => val.value"
                      :clearable="false"
                      :input-id="`var_type_${variable.id === 0 ? variable.custom_variable_id : variable.id}`"
                    />
                    <b-form-radio-group
                      v-else-if="variable.type === 'boolean'"
                      :id="`var_type_${variable.id === 0 ? variable.custom_variable_id : variable.id}`"
                      v-model="variable.customVarValue"
                      :options="radioOptions"
                      value-field="item"
                      text-field="name"
                      disabled-field="notEnabled"
                      class="demo-inline-spacing"
                    />
                    <b-form-input
                      v-else-if="variable.type === 'number'"
                      :id="`var_type_${variable.id === 0 ? variable.custom_variable_id : variable.id}`"
                      v-model="variable.customVarValue"
                      :placeholder="$t(variable.customVarLabel)"
                      :value="variable.customVarValue"
                    />
                    <b-form-input
                      v-else
                      :id="`var_type_${variable.id === 0 ? variable.custom_variable_id : variable.id}`"
                      v-model="variable.customVarValue"
                      :placeholder="$t(variable.customVarLabel)"
                      :value="variable.customVarValue"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <label
                      :id="'general_custom_fields-dateerror-'+variable.custom_variable_id"
                      style="color: red; display:none;"
                    >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
                  </validation-provider>
                </b-form-group>
              </div></b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BFormGroup, BButton, BForm, BOverlay, BFormTextarea, BFormDatepicker, BFormRadioGroup, BFormInput, BCardHeader, BCardTitle, BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import VueTimepicker from 'vue2-timepicker'
import useAppConfig from '@core/app-config/useAppConfig'
import 'vue2-timepicker/dist/VueTimepicker.css'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import axios from '@axios'
import router from '@/router'
import Cleave from 'vue-cleave-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import constants from '@/app-configs/constants'
import { EventBus } from '@/event-bus'
// import constants from '@/app-configs/constants'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BOverlay,
    vSelect,
    BFormTextarea,
    BFormDatepicker,
    BFormRadioGroup,
    BFormInput,
    BCardHeader,
    BCardTitle,
    ValidationProvider,
    ValidationObserver,
    BButton,
    VueTimepicker,
    Cleave,
    BInputGroupAppend,
    BInputGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    // variables: {
    //   type: Array,
    //   required: true,
    // },
    // airports: {
    //   type: Array,
    //   required: true,
    // },
    // getDetails: {
    //   type: Function,
    //   required: true,
    // },
  },
  data() {
    return {
      // skinColor: '',
      customVariableBusy: true,
      radioOptions: [
        { item: 'true', name: 'True' },
        { item: 'false', name: 'False' },
      ],
      dateChange: false,
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
      caseGeneralDates: {},
      variables: [],
      airports: [],
    }
  },
  watch: {
    skin: {
      handler() {
        this.timeFieldColor()
      },
    },
  },
  setup() {
    const { skin } = useAppConfig()

    return {
      // Skin
      skin,
    }
  },
  created() {
  },
  mounted() {
    this.timeFieldColor()
  },
  methods: {
    async fetchInitialData() {
      await this.getCustomVariables()
    },
    async getCustomVariables() {
      this.customVariableBusy = true
      const caseID = this.$route.params.id
      const url = `${constants.baseUrlV2}/debt-case/custom-vars-data/${caseID}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.customVariableBusy = false
          this.variables = response.data.data.custom_variables
          this.airports = response.data.data.options
          this.variables.forEach(element => {
            if (element.type === 'select') {
              const customOldVarValue = element.customVarValue !== null ? element.customVarValue : ''
              this.$set(element, 'customOldVarValue', customOldVarValue)
            }
            if (element.type === 'date') {
              // this.$set(this.caseGeneralDates, element.customVarLabel, element.customVarValue)
              // this.$set(this.caseGeneralDates, `da${element.customVarLabel}`, this.$DAformattedDate(element.customVarValue))
              const regexPattern = /^\d{2}-\d{2}-\d{4}$/
              const fDate = this.$DAformattedDate(element.customVarValue !== null ? element.customVarValue : '')
              if (regexPattern.test(fDate)) {
                this.$set(this.caseGeneralDates, `da${element.customVarLabel}`, this.$DAformattedDate(element.customVarValue))
              } else {
                this.$set(this.caseGeneralDates, `da${element.customVarLabel}`, '')
              }
            }
            if (element.type === 'time' && element.customVarValue === null) {
              this.$set(element, 'customVarValue', '')
            }
          })
        }
      })
    },
    validateDate(type, value, label, index) {
      if (type === 0) {
        const regexPattern = /^\d{4}-\d{2}-\d{2}$/
        const fDate = this.$FormformattedDate(value)
        if (regexPattern.test(fDate)) {
          this.variables[index].customVarValue = fDate
        } else {
          this.variables[index].customVarValue = ''
        }
      } else {
        const regexPattern = /^\d{2}-\d{2}-\d{4}$/
        const fDate = this.$DAformattedDate(value)
        if (regexPattern.test(fDate)) {
          this.caseGeneralDates[`da${label}`] = fDate
        } else {
          this.caseGeneralDates[`da${label}`] = ''
        }
      }
    },
    changeFormat(index, value) {
      const parts = value.split('-')
      const day = Number(parts[2])
      const month = Number(parts[1])
      const year = Number(parts[0])
      const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`
      this.variables[index].customVarValue = formattedDate
    },
    getRules(isRequired, type) {
      let validationRules = ''
      if (isRequired === 1 && type === 'date') {
        validationRules = 'required|datePattern'
      }
      if (isRequired === 1 && type !== 'date') {
        validationRules = 'required'
      }
      if (isRequired !== 1 && type === 'date') {
        validationRules = 'datePattern'
      }
      return validationRules
    },
    timeFieldColor() {
      const fields = document.getElementsByClassName('time-picker')
      Array.from(fields).forEach(field => {
        const dropdownChildren = field.children[1].classList.contains('dropdown') ? field.children[1] : field.children[2]
        // eslint-disable-next-line no-param-reassign
        dropdownChildren.firstChild.style.backgroundColor = this.skin === 'light' ? 'white' : '#3b4662'
        // eslint-disable-next-line no-param-reassign
        if (this.skin === 'light') {
          dropdownChildren.firstChild.children[0].classList.remove('timepick-hours')
          dropdownChildren.firstChild.children[1].classList.remove('timepick-minutes')
        } else {
          dropdownChildren.firstChild.children[0].classList.add('timepick-hours')
          dropdownChildren.firstChild.children[1].classList.add('timepick-minutes')
        }
      })
    },
    makeSuccessToast() {
      this.$bvToast.toast('Case Details have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    updateGeneralInfo(evt) {
      evt.preventDefault()
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            const dataVariables = []
            this.customVariableBusy = true
            this.variables.forEach(element => {
              const obj = {
                value: element.customVarValue,
                customVarLabel: element.customVarLabel,
              }
              if (element.type === 'select') {
                let oldOption = element.options.find(
                  option => option.value === element.customOldVarValue,
                )
                let newOption = element.options.find(
                  option => option.value === element.customVarValue,
                )

                if (oldOption === undefined && newOption === undefined) {
                  oldOption = this.airports.find(
                    option => option.value === element.customOldVarValue,
                  )
                  newOption = this.airports.find(
                    option => option.value === element.customVarValue,
                  )
                }

                obj.oldLabel = oldOption ? oldOption.label : ''
                obj.newLabel = newOption ? newOption.label : ''
              }
              dataVariables.push(obj)
            })
            const url = `${constants.serverBaseUrl}/api/v2/debtiaapp/case/save-custom-variables`
            axios.post(url, {
              variables: dataVariables,
              debt_case_id: router.currentRoute.params.id,
              action: 'edit',
            }).then(response => {
              if (response.status) {
                this.getCustomVariables()
                EventBus.$emit('refreshLogs')
                EventBus.$emit('refreshModules')
                EventBus.$emit('refreshSecondaryProcesses')
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CoffeeIcon',
                    variant: 'primary',
                    text: 'Information has been updated successfully.',
                  },
                })
              }
              this.customVariableBusy = false
            }).catch(error => {
              this.customVariableBusy = false
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Error',
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: error.response?.data?.message || 'something went wrong',
                },
              })
            })
          } else {
            this.customVariableBusy = false
            reject()
          }
        })
      })
    },
  },
  // mounted() {
  //   this.showModal()
  // },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.custom-control.custom-radio {
  margin-top: 5px !important;
}

.generalInfoHeader {
  padding: 0px 0px 20px 0px !important;
  border-bottom: 1px solid #d8d6de !important;
  margin-bottom: 15px !important;
}

.select-list .active {
  background-color: #219289 !important;
}

.timepick-minutes li{
  color: #d0d2d6 !important;
}

.timepick-hours li{
  color: #d0d2d6 !important;;
}
</style>
